import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, useIntl } from 'react-intl';
import Context from '@bibliocommons/context';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Link } from '@bibliocommons/base-links';

import './EventLocation.scss';

export default function EventLocation({ location, isVirtual, handleLocationClick }) {
  const { mobileApp } = useContext(Context);
  const intl = useIntl();
  const linkText = isVirtual ? intl.formatMessage({ id: 'online_event' }) : location?.get('name');

  const label = isVirtual ? (
    linkText
  ) : (
    <>
      <span aria-hidden>{linkText}</span>
      <ScreenReaderMessage>
        <FormattedMessage id="sr_event_location" values={{ locationName: linkText }} />
      </ScreenReaderMessage>
    </>
  );

  const url = !mobileApp || !isVirtual ? location?.get('webUrl') || location?.get('url') : null;

  const handleClick = () => {
    if (handleLocationClick) {
      handleLocationClick({ linkText });
    }
  };

  return (
    <div className="cp-event-location-name">
      {url ? (
        <Link href={url} dataKey="event-location-link" handleClick={handleClick}>
          {label}
        </Link>
      ) : (
        <span>{label}</span>
      )}
    </div>
  );
}

EventLocation.propTypes = {
  location: ImmutablePropTypes.map,
  isVirtual: PropTypes.bool,
  handleLocationClick: PropTypes.func
};
